import { httpCreate } from './http';

const http = httpCreate('/srv/gather-advert');

export const albumAdvert = {
	// 创建广告位
	createAdvert(gatherId, data) {
		return http.post(`/${gatherId}`, data);
	},
	// 修改广告位
	modifyAdvert(id, data) {
		return http.put(`/${id}`, data);
	},
	// 删除广告位
	deleteAdvert(id) {
		return http.delete(`/${id}`);
	},
	// 广告位列表
	getAdvertList(gatherId) {
		return http.get(`/list/${gatherId}`);
	},
	// 修改广告位顺序
	modifyAdvertSort(data) {
		return http.post('/updatePriority', data);
	},
	// 增加广告位点击量
	incrAdvertClickCount(gatherId, id) {
		return http.post(`/addClick/${gatherId}/${id}`);
	},
};
